import React from "react";
import { ModalPadrao } from "../../components/Base";
import { BtnSair } from "../../components/Buttons";
import PreVendaDetalhesPadrao from "./PreVendaDetalhesPadrao";

export default function PreVendaDetalheModal({ id, onCancel }) {
    return <ModalPadrao title="Pré-venda" visible={!!id} footer={<BtnSair onClick={onCancel} />} onCancel={onCancel} width={1000} >
        <PreVendaDetalhesPadrao id={id} onCancel={onCancel} />
    </ModalPadrao>;
}

